import React from 'react';
import PreDeliveringContainer from './PreDeliveringContainer';

const Store = (props) => (
  <PreDeliveringContainer
    createdSource="cms"
    title="Store Pre-Delivering List"
    {...props}
  />
);

export default Store;
